import {
    Component,
    ViewEncapsulation,
    computed,
    effect,
    inject,
    ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule, ViewportScroller } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import {
    HeaderComponent,
    FooterComponent,
    NavComponent,
    LayoutService,
    NavigationItem,
} from '@cvx/nextpage';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { CalAngularService } from '@cvx/cal-angular';
import { toSignal } from '@angular/core/rxjs-interop';
import { PersonaService } from './shared/services/persona.service';
import { fromEvent, map } from 'rxjs';
import { ScrollUpComponent } from "./shared/components/scroll-up/scroll-up.component";

@Component({
    selector: 'app-root',
    imports: [
    CommonModule,
    HeaderComponent,
    FooterComponent,
    NavComponent,
    RouterOutlet,
    NgbAlertModule,
    ScrollUpComponent
],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
    private readonly authService = inject(CalAngularService);
    private readonly layout = inject(LayoutService);
    private readonly personaService = inject(PersonaService);
    private readonly viewPort = inject(ViewportScroller);

    readonly loggedIn = toSignal(this.authService.isUserSignedIn(), {
        initialValue: false,
    });

    readonly welcome = computed(() => {
        if (this.loggedIn() && this.authService.cvxClaimsPrincipal?.name) {
            const formattedName = this.formatName(
                this.authService.cvxClaimsPrincipal.name
            );
            return `Hi! ${formattedName}`;
        }
        return '';
    });

    readonly navigationItems: NavigationItem[] = [
        // {
        //     label: 'home', link: '/overview'
        // },
        // {
        //     label: 'tooling',
        //     link: '/tooling',
        // },
        // {
        //     label: 'workflows', link: '/workflows'
        // },
        // {
        //     label: 'guides', link: '/guides'
        // }
    ];

    readonly links = [
        { href: 'https://devops.azure.chevron.com/', text: 'DevOps Pipeline' },
        {
            href: 'https://go.chevron.com/stackoverflow',
            text: 'Stack Overflow',
        },
        { href: 'https://go.chevron.com/cloudsupport', text: 'Support Ticket' },
    ];

    readonly showScroll = toSignal(
        fromEvent(window, 'scroll').pipe(
            map(() => this.viewPort.getScrollPosition()?.[1] > 0)
        )
    );

    constructor() {
        // Layout configuration
        this.layout.setClass('layout-39');

        // Centralized loading of data, user should be logged in
        effect(() => {
            if (this.loggedIn()) {
                console.log('User is now logged in');
                this.personaService.loadPersonas();
            } else {
                console.log('User is logged out');
            }
        });
    }

    onScrollTop(): void {
        this.viewPort.scrollToPosition([0, 0]);
    }

    private formatName(name: string): string {
        if (!name) return '';

        if (name.includes(',')) {
            const parts = name.split(',').map((part) => part.trim());
            if (parts.length === 2) {
                const [lastName, firstName] = parts;
                return `${firstName} ${lastName}`;
            }
        }

        return name;
    }
}
